import React from 'react';
import PropTypes from 'prop-types';
import Img from '../../../../Img';
import StatsigLink from '../../../../Links/StatsigLink';
import { useStatsig } from '../../../../hooks/useStatsig';
import config from '../../../../../../config';

import ToggleSwitch from './ToggleSwitch';
import styles from '../../collegeProspectTab.scss';

const DEFAULT_COLLEGE_AVATAR = '/img/v2/icons/icon-avatar-college.svg';

const CollegeRow = ({ college, onToggleAlert, onDelete }) => {
    const { featureGates } = useStatsig();
    const {
        id,
        name,
        clubProfileImages,
        p6,
        division,
        conference,
        isAlerted = false,
    } = college;

    const icon = clubProfileImages?.icon;
    const logoSrc = clubProfileImages?.default
        ? `/v1/club/${clubProfileImages.default}`
        : DEFAULT_COLLEGE_AVATAR;
    const logoSrcSet = icon?.oneX && icon?.twoX && icon?.threeX
        ? `/v1/club/${icon.oneX} 1x, /v1/club/${icon.twoX} 2x, /v1/club/${icon.threeX} 3x`
        : undefined;

    return (
        <div className={styles.collegeRow}>
            <div className={styles.collegeRowTopSection}>
                <div className={styles.collegeRowNameP6}>
                    <div className={styles.collegeRowMobileLogo}>
                        <Img
                            src={logoSrc}
                            srcSet={logoSrcSet}
                            defaultimg={DEFAULT_COLLEGE_AVATAR}
                            alt={name}
                        />
                    </div>
                    <div className={styles.collegeNameP6Stack}>
                        <div className={styles.collegeNameColumn}>
                            <div className={styles.collegeLogo}>
                                <Img
                                    src={logoSrc}
                                    srcSet={logoSrcSet}
                                    defaultimg={DEFAULT_COLLEGE_AVATAR}
                                    alt={name}
                                    className={styles.collegeLogoImg}
                                />
                            </div>
                            <StatsigLink
                                className={styles.collegeName}
                                gate={featureGates.CLUB_LINKS_REDIRECT}
                                enabledTo={`${config.nextAppHost}/college/${id}`}
                                disabledTo={`/colleges/${id}`}
                                data-testid={`college-row-${id}.college-link`}
                            >
                                {name}
                            </StatsigLink>
                        </div>
                        <div className={styles.collegeP6Column}>
                            {p6 || '-'}
                        </div>
                    </div>
                </div>
                <div className={styles.collegeDeleteColumn}>
                    <button
                        type="button"
                        className={styles.deleteButton}
                        onClick={() => onDelete(id)}
                        aria-label="Delete college"
                        data-testid="college-row.delete-btn"
                    >
                        <Img
                            src="/img/v4/icon-close-blue.svg"
                            alt="Delete"
                            className={styles.deleteIcon}
                        />
                    </button>
                </div>
            </div>

            <hr className={styles.collegeRowSeparator} />

            <div className={styles.collegeRowBottomSection}>
                <div className={styles.collegeRowDetailsColumn}>
                    <div className={styles.collegeDivisionColumn}>
                        {division || '-'}
                    </div>
                    <div className={styles.collegeConferenceColumn}>
                        {conference || '-'}
                    </div>
                </div>
                <div className={styles.collegeAlertColumn}>
                    <span className={styles.alertColumnInlineLabel} data-testid={`college-row-${id}.alert-label`}>
                        Alert College
                    </span>
                    <ToggleSwitch
                        id={id}
                        isOn={isAlerted}
                        onToggle={() => onToggleAlert(id)}
                    />
                </div>
            </div>
        </div>
    );
};

CollegeRow.propTypes = {
    college: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
        clubProfileImages: PropTypes.shape({
            default: PropTypes.string,
            icon: PropTypes.shape({
                oneX: PropTypes.string,
                twoX: PropTypes.string,
                threeX: PropTypes.string,
            }),
        }),
        p6: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        division: PropTypes.string,
        conference: PropTypes.string,
        isAlerted: PropTypes.bool,
        dateLastAlerted: PropTypes.string,
    }).isRequired,
    onToggleAlert: PropTypes.func,
    onDelete: PropTypes.func,
};

CollegeRow.defaultProps = {
    onToggleAlert: () => {},
    onDelete: () => {},
};

export default CollegeRow;
